/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Content_Feature_1_TitleInputs */

const en_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yardage & Targets`)
};

const es_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distancias y objetivos`)
};

const de_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernungen und Ziele`)
};

const zh_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`码数标识与目标`)
};

const ar_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المسافات والأهداف`)
};

const fr_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distances et cibles`)
};

const vi_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoảng cách và mục tiêu`)
};

const sw_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umbali na malengo`)
};

const th_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระยะและเป้าหมาย`)
};

const bs_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udaljenosti i ciljevi`)
};

const ja_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`距離表示とターゲット`)
};

const ko_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`거리 표시와 타깃`)
};

const pt_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distâncias e alvos`)
};

const it_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanze e bersagli`)
};

const sv_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avstånd och mål`)
};

const nl_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afstanden en doelen`)
};

const da_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afstande og mål`)
};

const nb_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avstander og mål`)
};

const fi_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etäisyydet ja kohteet`)
};

const pl_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odległości i cele`)
};

const ru_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дистанции и цели`)
};

const tr_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesafeler ve hedefler`)
};

const hi_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दूरी और लक्ष्य`)
};

const id_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jarak dan target`)
};

const ms_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jarak dan sasaran`)
};

const cs_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vzdálenosti a cíle`)
};

const el_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αποστάσεις και στόχοι`)
};

const he_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מרחקים ויעדים`)
};

const af_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afstande en teikens`)
};

const hu_range_content_feature_1_title = /** @type {(inputs: Range_Content_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Távolságok és célok`)
};

/**
* | output |
* | --- |
* | "Yardage & Targets" |
*
* @param {Range_Content_Feature_1_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_content_feature_1_title = /** @type {((inputs?: Range_Content_Feature_1_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Content_Feature_1_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_content_feature_1_title(inputs)
	if (locale === "de") return de_range_content_feature_1_title(inputs)
	if (locale === "zh") return zh_range_content_feature_1_title(inputs)
	if (locale === "ar") return ar_range_content_feature_1_title(inputs)
	if (locale === "fr") return fr_range_content_feature_1_title(inputs)
	if (locale === "vi") return vi_range_content_feature_1_title(inputs)
	if (locale === "sw") return sw_range_content_feature_1_title(inputs)
	if (locale === "th") return th_range_content_feature_1_title(inputs)
	if (locale === "bs") return bs_range_content_feature_1_title(inputs)
	if (locale === "ja") return ja_range_content_feature_1_title(inputs)
	if (locale === "ko") return ko_range_content_feature_1_title(inputs)
	if (locale === "pt") return pt_range_content_feature_1_title(inputs)
	if (locale === "it") return it_range_content_feature_1_title(inputs)
	if (locale === "sv") return sv_range_content_feature_1_title(inputs)
	if (locale === "nl") return nl_range_content_feature_1_title(inputs)
	if (locale === "da") return da_range_content_feature_1_title(inputs)
	if (locale === "nb") return nb_range_content_feature_1_title(inputs)
	if (locale === "fi") return fi_range_content_feature_1_title(inputs)
	if (locale === "pl") return pl_range_content_feature_1_title(inputs)
	if (locale === "ru") return ru_range_content_feature_1_title(inputs)
	if (locale === "tr") return tr_range_content_feature_1_title(inputs)
	if (locale === "hi") return hi_range_content_feature_1_title(inputs)
	if (locale === "id") return id_range_content_feature_1_title(inputs)
	if (locale === "ms") return ms_range_content_feature_1_title(inputs)
	if (locale === "cs") return cs_range_content_feature_1_title(inputs)
	if (locale === "el") return el_range_content_feature_1_title(inputs)
	if (locale === "he") return he_range_content_feature_1_title(inputs)
	if (locale === "af") return af_range_content_feature_1_title(inputs)
	if (locale === "hu") return hu_range_content_feature_1_title(inputs)
	return en_range_content_feature_1_title(inputs)
});